import { render } from "./ModalFileEdit.vue?vue&type=template&id=7c247ee8&ts=true"
import script from "./ModalFileEdit.vue?vue&type=script&lang=ts"
export * from "./ModalFileEdit.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\anc-transparencia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__